import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import { Trip } from '../TripHistoryList'
import { List, Checkbox } from 'antd'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useMap } from '@vis.gl/react-google-maps'
import { orange } from '@ant-design/colors'

const { Item } = List

interface IProps {
  trip: Trip
}

interface TripDetail {
  lat: number
  lng: number
  sample_time: string
  speed: string,
  unit_name: string
}

const TripHistoryItem: FunctionComponent<any> = (props: IProps) => {
  const { trip } = props
  const client = useFeathersClient()
  const [enabled, setEnabled] = useState<boolean>(false)
  const map = useMap()

  const color = orange[5]

  const arrowSymbol = {
    path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
    scale: 2, // Size of the arrow
    strokeColor: color, // Arrow color
    fillColor: color // Fill color of the arrow
  }

  const polylineRef = useRef(new google.maps.Polyline({
    map,
    strokeColor: color,
    strokeOpacity: 1.0,
    strokeWeight: 5,
    icons: [
      {
        icon: arrowSymbol,
        offset: '100%', // Place the first arrow at the end of the polyline
        repeat: '50px' // Distance between repeated arrows
      }
    ]
  }))

  useEffect(() => {
    polylineRef.current.setMap(enabled ? map : null)
  }, [enabled, map])

  useEffect(() => {
    if (!enabled) return
    if (!trip) return

    const polylineCurrent = polylineRef.current

    const markers: google.maps.marker.AdvancedMarkerElement[] = []

    const createPath = (tripDetails: TripDetail[]) => {
      const path: google.maps.LatLng[] = []
      for (const tripDetail of tripDetails) {
          const latLng = new google.maps.LatLng(tripDetail.lat, tripDetail.lng)
          const marker = new google.maps.marker.AdvancedMarkerElement({
            position: latLng,
            map,
            title: `Time: ${tripDetail.sample_time}\nSpeed: ${Number(tripDetail.speed || 0).toFixed(0)}`
          })
          markers.push(marker)
          path.push(latLng)
      }
      return path
    }

    client
      .service('trip-history')
      .get(trip.trip_id, {
        query: {
          sim_id: trip.sim_id
        }
      })
      .then((response: TripDetail[]) => {
        polylineRef.current.setPath(createPath(response))
        const path = polylineRef.current.getPath()
        const bounds = new google.maps.LatLngBounds()
        path.forEach((latLng: google.maps.LatLng) => bounds.extend(latLng))
        map?.fitBounds(bounds, 100)
      })
      .catch(console.error)

    return () => {
      polylineCurrent.setPath([])
      markers.forEach((marker: google.maps.marker.AdvancedMarkerElement) => marker.map = null)
    }
  }, [enabled, client, trip, map])

  return (
    <Item
      actions={[
        <Checkbox key={'trip-enable'} onChange={(e: any) => setEnabled(e.target.checked)} checked={enabled} />
      ]}
    >
      <Item.Meta title={trip.unit_name} description={trip.sample_time} />
    </Item>
  )
}

export default TripHistoryItem
